<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && buttons.length >= 1'>
      <RF-Aba :cpntButtons='buttons'></RF-Aba>
    </template>
  </div>
</template>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        buttons: []
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 26 ], null, [ 49 ], null, [ 544 ], null, true) === true) {
        this.contratosConfigIniciar()
      }
    },
    methods: {
      contratosConfigIniciar: function () {
        // SETA O STATUS DA TELA
        this.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // ADICIONA OS BUTTONS DAS ABAS
        this.buttons.push({ nome: 'Comunicação D4Sign', router: this.$router.resolve({ name: 'contratos_config_com', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'contratos_config_com' ] })

        this.buttons.push({ nome: 'Signatários Adicionais', router: this.$router.resolve({ name: 'contratos_config_ass', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'contratos_config_ass' ] })

        this.buttons.push({ nome: 'Diretórios na D4Sign', router: this.$router.resolve({ name: 'contratos_config_dir', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'contratos_config_dir' ] })

        // SETA O STATUS DA TELA
        this.statusGeral = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
